module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAgCAYAAAAffCjxAAAAAXNSR0IArs4c6QAAAShJREFUSA2l1j0OgjAUB3BbXYwDO9cANj9WoifxCi7Gi3gLXY3GjXACJxcGNwfiJPh/RggGaF/bJg0N7fvR17SAGFiWIAimCN2jelLKtbBxoihaFEVxQOzkF/+QplAHQsTTaEY9SA4oZs+oD8H6rNI0vbJmpEKSJDlTblqIg2ghLqKETJBeyBTphGyQFmSL/EEuSA25IgTJMAw3OIAntKsDSPdz7Nhltdnohq6MyrLcYVC9MYUQL1RCLrrgZn/rrAFu9rPbEk/fYnQzeoxUj1i3OVvBwG9KisVmp1ivjStWQ5SGC/YHuWAtyBbrhGywXsgUU0ImmBbiYiyIg7EhFYa+2AhSYLfW6afBqkLvKPq6Ygx9qqviDauWyTXLsrvv+/S+mqG+6bfmAy4X90/wzhZ7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/black_return.png
// module id = +tk5
// module chunks = 0